import FormButton from 'src/components/common/FormButton/FormButton'
import styled from 'styled-components'
import v3Logo from '../../../assets/v3-logo.svg'

const DOWNLOAD_URL = 'https://testflight.apple.com/join/knr5A8IS'

const Card = styled.div`
    padding: 20px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.05);
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

const Icon = styled.img`
    width: 48px;
    height: 48px;
    border-radius: 10px;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);
`

const Title = styled.h3`
    font-weight: 700;
    font-size: 18px;
`

const Subtitle = styled.p`
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
`

/** The app download, shown under the subscription now that Downloads isn't its own page. */
const DownloadCard = () => (
    <Card>
        <Row>
            <Icon src={v3Logo} alt="" />
            <div>
                <Title>Download SwiftSole V3</Title>
                <Subtitle>Version 3.0.1 · iOS via TestFlight</Subtitle>
            </div>
        </Row>
        <FormButton fullWidth color="purple" onClick={() => window.open(DOWNLOAD_URL, '_blank', 'noopener')}>
            Open Download Link
        </FormButton>
    </Card>
)

export default DownloadCard
